$(document).on('nfFormReady', function () {
    $('.join-us-form select').minimalect();
    $('.salary-field').on('keypress', function (e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });
});



// WEBPACK FOOTER //
// ./scripts/modules/join-us-form.js